import type { HelpArticle, HelpVisibility } from '@nucleus-commerce/api-client/admin';

/** Live (shoppers can read it), Internal (published for staff only) or Draft. */
export type HelpArticleState = 'live' | 'internal' | 'draft';

/** What the storefront does with a saved article. The backend's `live` is the authority. */
export function articleState(article: Pick<HelpArticle, 'status' | 'live'>): HelpArticleState {
  if (article.status === 'draft') return 'draft';
  return article.live ? 'live' : 'internal';
}

/**
 * The same question for unsaved form values: published, public and not in an internal category
 * is live; published otherwise stays internal.
 */
export function draftState(
  status: HelpArticle['status'],
  visibility: HelpVisibility,
  categoryVisibility: HelpVisibility | null,
): HelpArticleState {
  if (status === 'draft') return 'draft';
  return visibility === 'public' && categoryVisibility !== 'internal' ? 'live' : 'internal';
}
